// This file is automatically generated. Do not edit manually.

import { t } from "i18next";

export const SafetyControlSurveyTypeValues = ["TR", "ELMERI"] as const;

export type SafetyControlSurveyType = (typeof SafetyControlSurveyTypeValues)[number];

export const getSafetyControlSurveyTypeLabels = () => ({
	TR: t("tr"),
	ELMERI: t("elmeri"),
});

export const getSafetyControlSurveyTypeLabel = (value: SafetyControlSurveyType): string => {
	return getSafetyControlSurveyTypeLabels()[value];
};
